export default __webpack_public_path__ + "static/media/building.33b84d52.svg";